import request from '@/config/request';
import API from '@/config/domain';

export default {
  // 获取验证码
  getVerify(params, callback) {
    return request(API.BASEAPI + 'open/captcha', 'get', '', 'json').then((data) => {
      callback(data);
    })
  },
  // 账号密码登录
  loginIn(params, callback) {
    return request(API.BASEAPI + 'open/platform/login', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 免登陆查询用户信息
  thirdLogin(params, callback) {
    return request(API.BASEAPI + 'open/platform/thirdLogin', 'get', params, '', '', 'msg').then((data) => {
      callback(data);
    });
  },
  // 2.ca登录获取随机数接口
  getNonce(params, callback) {
    return request(API.BASEAPI + 'open/platform/getNonce', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 3.ca登录接口
  caLogin(params, callback) {
    return request(API.BASEAPI + 'open/platform/caLogin', 'post', params).then((data) => {
      callback(data);
    });
  },
};